export default "__VITE_ASSET__DcvnlGiD__"